import React from "react";
import { TableCell, TableHead, TableRow } from "@mui/material";
import { getCols } from "./getCols";
import { useBidContext } from "../Bid.context";

export default function BidTableHeader() {
  const { mrqData, selectedBidVendors } = useBidContext();
  return (
    <TableHead>
      <TableRow>
        {getCols(mrqData, selectedBidVendors).map((col) => (
          <TableCell
            key={col?.id}
            align={col?.align}
            style={{
              minWidth: col?.minWidth,
              fontWeight: "bold",
              background: "#3b003b",
            }}
          >
            <div style={{ fontSize: 15, paddingBottom: 7 }}>{col?.label}</div>
            {col?.isVendor ? (
              <div>
                {col?.id === "selected" && (
                  <div
                    style={{
                      display: "inline-block",
                      width: "25%",
                      fontWeight: 400,
                      borderRight: "1px solid #ccc",
                    }}
                  >
                    Name
                    <br />
                    <span style={{ fontSize: "0.8em", fontWeight: "normal" }}>
                      {" "}
                      -
                    </span>
                  </div>
                )}
                <div
                  style={{
                    display: "inline-block",
                    width: col.id === "selected" ? "25%" : "28%",
                    padding: 2,
                    borderRight: "1px solid #ccc",
                    height: "100%",
                    fontWeight: 400,
                  }}
                >
                  Time
                  <br />
                  <span style={{ fontSize: "0.8em", fontWeight: "normal" }}>
                    (days)
                  </span>
                </div>
                <div
                  style={{
                    display: "inline-block",
                    width: col?.id === "selected" ? "25%" : "28%",
                    padding: 2,
                    borderRight: "1px solid #ccc",
                    fontWeight: 400,
                  }}
                >
                  Cost/Unit <br />
                  <span style={{ fontSize: "0.8em", fontWeight: "normal" }}>
                    (USD)
                  </span>
                </div>
                <div
                  style={{
                    display: "inline-block",
                    width: col?.id === "selected" ? "25%" : "28%",
                    padding: 2,
                    borderRight: "1px solid #ccc",
                    fontWeight: 400,
                  }}
                >
                  Data Sheet <br />
                </div>
                {col?.id !== "selected" && (
                  <span
                    style={{
                      display: "inline-block",
                      width: "15%",
                    }}
                  ></span>
                )}
                {!["selected", "est"].includes(col?.id) && (
                  <div
                    style={{
                      display: "inline-block",
                      width: "20%",
                      fontWeight: 400,
                      borderRight: "1px solid #333",
                    }}
                  ></div>
                )}
              </div>
            ) : (
              ""
            )}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}
